import { TranslateService } from '@ngx-translate/core';
import { SharedService } from 'src/app/Service/shared.service';
import { Global } from './../../Service/global.service';
import { HomeService } from './../../Service/home.service';
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import * as _ from 'lodash';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser'
import { forkJoin } from 'rxjs';
import { title } from 'process';
declare var $: any;
@Component({
  selector: 'app-port-maroc',
  templateUrl: './port-maroc.component.html',
  styleUrls: ['./port-maroc.component.scss']
})
export class PortMarocComponent implements OnInit, OnDestroy {

  constructor(private service: HomeService, private global: Global, private router: Router, private homeService: HomeService,
    private sharedService: SharedService, private translate: TranslateService, private sanitazer: DomSanitizer) { }
  ports = [];
  filterActivities = [];
  bloctitle = {
    title: '',
    content: ''
  }
  regions = [];
  selectedRegion = "";
  selectedPort = null
  selectedActivite = [];
  selectedPortPath = null;
  isArab = false;
  filterRegions = [];
  cartePort = true;
  portLoaded = false;
  currentlg
  currentUrl
  detailedPort = null;
  slick = null;
  maxNumPort = 0;
  currentPort = 0;
  ngOnInit(): void {
    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {
      this.currentlg = lg.code;
      this.currentUrl = lg.url
      this.currentlg == "ar" ? this.isArab = true : this.isArab = false;

      this.sharedService.getBlocDescriptionByCode(lg.url, 'PortMaroc1').subscribe(datas => {
        this.bloctitle.title = datas['value'][0].Title;
        this.bloctitle.content = datas['value'][0].Contenu;
      })

      this.service.getPortnet().subscribe(datas => {
        this.regions = [];
        this.ports = [];
        datas['value'].forEach(element => {
          const imgPort = element.AttachmentFiles.length > 0 ? this.global._basedUrl + element.AttachmentFiles[0].ServerRelativeUrl : "assets/media/images/port_casa_s.jpg"
          let activites = '';
          element.CodeActivitePortuaire.forEach(item => {
            if (item === 'activite.passagers') {
              activites += "<img src='assets/media/images/passager.png'>"
            } else if (item === 'activite.peche') {
              activites += "<img src='assets/media/images/p-che.png'>"
            } else if (item === 'activite.Plaisance') {
              activites += "<img src='assets/media/images/passager.png'>"
            } else {
              activites += "<img src='assets/media/images/commerce.png'>"
            }
          });
          const titre = this.translate.instant(element.CodePort);
          const region = this.translate.instant(element.CodeRegion);
          this.maxNumPort < element.OrdreMap ? element.OrdreMap : this.maxNumPort;
          if (element.GInfo !== null && element.GInfo !== undefined && element.GInfo !== '') {
            const obj = {
              gInfo: this.returnJson(element.GInfo),
              circleInfo: this.returnJson(element.CircleInfo),
              pathInfo: this.returnJson(element.PathInfo),
              codeActivitePortuaire: element.CodeActivitePortuaire,
              CodePort: element.CodePort,
              textInfo: this.returnJson(element.TextInfo),
              CodeRegion: element.CodeRegion,
              activite: activites,
              pathPort: element.CodePort.toLowerCase().split('ports.port')[1],
              portImage: imgPort,
              toolTip: this.returnTitlePort(element),
              TitleTrans: titre,
              regionTrans: region,
              ordrePort: element.OrdreMap
            }
            if (this.regions.indexOf(element.CodeRegion) === -1) {
              this.regions.push(element.CodeRegion);
            }
            this.ports.push(obj);
          }
        })






      });
    });
  }
  ngOnDestroy(): void {
    $('[data-toggle="tooltip"]').tooltip('dispose');
  }
  getPortDetail(port) {


    this.currentPort = port.ordrePort;
    this.portLoaded = false;
    this.detailedPort = {
      port: port,
      mvmEntre: [],
      mvSortie: [],
      links: [],
      chantiers: []
    }
    forkJoin([this.homeService.getPortSections(), this.homeService.getChantiersInfrastructures(this.currentUrl)
      , this.homeService.getMvmNaviresArrivees(), this.homeService.getMvmNaviresDeparts()]).subscribe(datas => {
        const menuPorts = datas[0]['value']
        const mvmEntre = datas[2];
        const mvmSortie = datas[3];

        const requetes = [];
        menuPorts.forEach(section => {
          requetes.push(this.homeService.getAllServiceDataId(section.ListeReference, this.currentlg));
        });
        forkJoin(requetes).subscribe(dataPorts => {

          const pathPort = port.CodePort.toLowerCase().split('ports.port')[1];
          const urlPortStatic = '/port/' + pathPort + '/page'
          const mvArrive = [];
          const mvSortie = [];
          const liens = [];
          const gchantiers = [];
          // Grand Chantiers
          datas[1]['value'].forEach(element => {
            if (element.CodePort === port.CodePort) {
              const obj = {
                Titre: element.Title ? element.Title : "",
                Port: element.CodePort ? element.CodePort : "",
                Id: element.Id ? element.Id : "",
                PortImage: element.LienImageProjet !== '' && element.LienImageProjet !== null ? this.global._basedUrl + element.LienImageProjet : this.currentlg + 'assets/media/images/img-01.png'
              }
              gchantiers.push(obj);
            }
          });
          // lien Ports 
          for (let i = 0; i < dataPorts.length; i++) {
            if (dataPorts[i]['value'].length > 0) {
              const obj = {
                'Title': this.currentlg === 'fr' ? menuPorts[i].Title : this.currentlg === 'ar' ? menuPorts[i].TitleAR : menuPorts[i].TitleEN,
                'Url': [urlPortStatic, menuPorts[i].ApplicationUrl]
              }
              liens.push(obj);
            }
          }
          // Liste Entree
          //@ts-ignore
          mvmEntre.forEach(element => {
            if (element.pORTField.toLowerCase() === port.textInfo.id.toLowerCase()) {
              mvArrive.push(element);
            }
          });
          //@ts-ignore
          mvmSortie.forEach(element => {
            if (element.pORTField.toLowerCase() === port.textInfo.id.toLowerCase()) {
              mvSortie.push(element);
            }
          });
          this.detailedPort.mvmEntre = mvArrive;
          this.detailedPort.mvSortie = mvSortie;
          this.detailedPort.links = liens;
          this.detailedPort.chantiers = gchantiers;

          this.portLoaded = true;
          $('.modal-body .accordion').on('shown.bs.collapse', function () {
            if ($('.modal-body .accordion .slick-list').width() == 0) {

              setTimeout(() => {
                $('.card-slider').slick('unslick');
                $('.card-slider').slick({
                  infinite: true,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  dots: false,
                });
              }, 1000)

            }
          })
          document.getElementById('collapseInit').click();

        });
      })

  }
  nextPort(suivant) {
    let opt = 0
    if (suivant) {
      opt = this.currentPort === this.maxNumPort ? this.currentPort = 1 : this.currentPort + 1
    } else {
      opt = this.currentPort === 1 ? this.currentPort = this.maxNumPort : this.currentPort - 1
    }
    let port;
    this.ports.forEach(element => {

      if (element.ordrePort === opt) {
        port = element;
      }
    });
    this.getPortDetail(port);
  }
  workSlick(chantiers) {

    if (chantiers.length > 0) {
      try {
        this.slick !== null ? this.slick = $('.card-slider').slick('unslick') : '';
      } catch {

      }
      this.slick = $('.card-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
      });
    }

  }
  navigateToServicePort(item) {
    ;
    document.getElementById('btnCloseModal').click();
    this.router.navigate(item);
  }
  navigateChantier(item) {

    document.getElementById('btnCloseModal').click();
    this.router.navigate(['/grands-chantiers/chantiers-infrastructures', item.Id]);
  }
  convertTime(t) {
    return new Date(+t.split("(")[1].split(")")[0].split("+")[0]).toLocaleTimeString().substring(0, 5)
  }
  returnTitlePort(portItem) {

    const imgPort = portItem.AttachmentFiles.length > 0 ? this.global._basedUrl + portItem.AttachmentFiles[0].ServerRelativeUrl : "assets/media/images/port_casa_s.jpg"
    let activites = '';
    portItem.CodeActivitePortuaire.forEach(element => {
      if (element === 'activite.passagers') {
        activites += "<img src='assets/media/images/passager.png'>"
      } else if (element === 'activite.peche') {
        activites += "<img src='assets/media/images/p-che.png'>"
      } else if (element === 'activite.Plaisance') {
        activites += "<img src='assets/media/images/passager.png'>"
      } else {
        activites += "<img src='assets/media/images/commerce.png'>"
      }
    });
    const titre = this.translate.instant(portItem.CodePort);
    const region = this.translate.instant(portItem.CodeRegion);

    return "<div class='visuel'><img width='320' height='120' src='" + imgPort + "'></div><div class='tooltip-content d-flex flex-column justify-content-between'><div class='services align-self-start w-100'>" + activites + "</div><div class='align-self-end w-100'><div class='titre'>" + titre + "</div><div class='p'>" + region + "</div></div></div>";




  }
  tooltiphover(e) {
    setTimeout(() => {
      $('[data-toggle="tooltip"]').tooltip();
    }, 100);
  }

  ngAfterViewInit() {

    var checkExist = setInterval(function () {
      if ($('[data-toggle="tooltip"]').length > 0) {

        clearInterval(checkExist);

        if ($('[data-toggle="tooltip"]').length > 0) {
          $('[data-toggle="tooltip"]').tooltip();

        }
        // $('[data-toggle="tooltip"]').on('show.bs.tooltip', function (e) {
        //   $("div.tooltip-inner > div.visuel > img").on("load",()=>{
        //     $(this).tooltip('update');
        //   })
        // })
        $('tspan').on('click', function (e) {
          $(this).addClass('active');
          var portID = $(this).parent().attr('id');
          $('circle#' + portID).addClass('active');
        })
        $('.modal').on('hidden.bs.modal', function (event) {
          $('tspan').removeClass('active');
          $('circle').removeClass('active');
        })

      }

    }, 100);
  }
  returnJson(obj) {
    if (obj === null || obj === undefined || obj === '') {
      return null;
    } else {
      try {
        return JSON.parse(obj);
      } catch {
        return null
      }
    }
  }
  filterPortByActivities(filter) {
    if (this.filterActivities.indexOf(filter) === -1) {
      this.filterActivities[0] = filter
    } else {
      this.filterActivities.pop();
    }
    // if (this.filterActivities.indexOf(filter) === -1) {
    //   this.filterActivities.push(filter);
    // } else {
    //   _.remove(this.filterActivities, function (currentObject) {
    //     return currentObject === filter;
    //   });
    // }
  }
  filterPortByRegion(filter) {
    if (this.filterRegions.indexOf(filter) === -1) {
      this.filterRegions.push(filter);
    } else {
      _.remove(this.filterRegions, function (currentObject) {
        return currentObject === filter;
      });
    }
  }
  navigateTo(port) {
    this.router.navigate(['/port', port.pathPort, 'page', 'Presentation']);
  }
  ReturnPortName(portCode) {
    return 'portName.' + portCode.split('.')[1];
  }
  changeRegion() {
    this.selectedPort = null;
    this.selectedActivite = [];
    this.selectedPortPath = null;
  }
  getPortActivity(item) {

    if (item !== null) {
      this.ports.forEach(element => {
        if (element.CodePort === item) {
          this.selectedActivite = element.codeActivitePortuaire;
          this.selectedPortPath = element;
        }
      });
    } else {
      this.selectedActivite = [];
    }

  }

}





